/**
 * Dates as the shop sees them.
 *
 * The business runs on Singapore time. An iPad whose clock is set to somewhere else still
 * has to put a sale at 00:30 on the Singapore day, because that is the day the shop
 * counts its money for.
 */

export function singaporeToday(): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Singapore",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
  // en-CA already writes YYYY-MM-DD.
  return parts;
}

/**
 * The Singapore day a moment falls on, YYYY-MM-DD. Cutting a timestamp at ten characters
 * gives the UTC day instead, which is yesterday for the first eight hours of every morning.
 */
export function singaporeDay(instant: string): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Singapore",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(instant));
}

/** "24 Sept": a day as it is written everywhere on screen, rather than 2026-09-24. */
export function shortDay(day: string): string {
  return new Date(`${day}T00:00:00`).toLocaleDateString("en-SG", { day: "numeric", month: "short" });
}

/** "3 weeks ago" for a price date, because the age is what staff need to judge it. */
export function ageOf(isoDate: string | null): string {
  if (!isoDate) return "never set";
  const then = Date.parse(`${isoDate}T00:00:00+08:00`);
  const now = Date.parse(`${singaporeToday()}T00:00:00+08:00`);
  const days = Math.round((now - then) / 86_400_000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 14) return `${days} days ago`;
  if (days < 60) return `${Math.round(days / 7)} weeks ago`;
  return `${Math.round(days / 30)} months ago`;
}
